import Vue from 'vue'
import API from './API'
import helpers from './helpers'
import VueScrollTo from 'vue-scrollto'
import CKEditor from '@ckeditor/ckeditor5-vue'
import LayoutEditorPage from '@/components/Layouts/EditorPage/Index.vue'
import ButtonClipboard from '@/components/UI/ButtonClipboard'
import ImageTooltip from '@/components/UI/ImageTooltip'
import DatePicker from '@/components/Form/UI/DatePicker'
import Button from '@/components/UI/Button'
import SelectResponse from '@/components/Form/UI/Selects/SelectResponse/Index'
import SelectResponseAutoComplete from '@/components/Form/UI/Selects/SelectResponseAutoComplete/Index'
import ImageUploader from '@/components/Form/UI/ImageUploader'
import VueAvatar from './vueAvatar'
import VueCustomScrollbar from 'vue-custom-scrollbar'

export default function () {
  Vue.use(API)
  Vue.use(helpers)
  Vue.use(CKEditor)
  Vue.use(VueScrollTo)
  Vue.component(DatePicker.name, DatePicker)
  Vue.component(Button.name, Button)
  Vue.component(LayoutEditorPage.name, LayoutEditorPage)
  Vue.component(SelectResponse.name, SelectResponse)
  Vue.component(SelectResponseAutoComplete.name, SelectResponseAutoComplete)
  Vue.component(ButtonClipboard.name, ButtonClipboard)
  Vue.component(ImageTooltip.name, ImageTooltip)
  Vue.component(ImageUploader.name, ImageUploader)
  Vue.component('VueAvatar', VueAvatar)
  Vue.component('VueCustomScrollbar', VueCustomScrollbar)
}
